// src/components/Student/LiveClass/RoomDetailModal.js
import React from 'react';

export default function RoomDetailModal({ room, open, onClose }) {
  if (!open || !room) return null;
  return (
    <div className="modal-overlay" style={{ position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0,0,0,0.4)', zIndex: 1000 }}>
      <div className="modal-content" style={{ background: '#fff', margin: '5% auto', padding: 24, borderRadius: 8, maxWidth: 500, position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 8, right: 8 }}>X</button>
        <h3>{room.name}</h3>
        <p><b>Descripción:</b> {room.description}</p>
        <p><b>Fecha y hora:</b> {new Date(room.scheduled_at).toLocaleString()}</p>
        <p><b>Duración:</b> {room.duration_minutes} min</p>
        <p><b>Profesor:</b> {room.teacher ? `${room.teacher.firstname} ${room.teacher.lastname}` : '-'}</p>
        <p><b>Estado:</b> {room.status}</p>
        {room.meeting_url && (
          <p><b>Enlace de la clase:</b> <a href={room.meeting_url} target="_blank" rel="noopener noreferrer">{room.meeting_url}</a></p>
        )}
        {room.recording_url && (
          <p><b>Grabación:</b> <a href={room.recording_url} target="_blank" rel="noopener noreferrer">Ver grabación</a></p>
        )}
      </div>
    </div>
  );
}
